import { NewsAttachment, NewsPost, NewsPostResponse } from './types'

export function toNewsAttachment(response: NewsAttachment): NewsAttachment {
  return {
    id: response.id,
    filename: response.filename,
  }
}

export function toNewsPost(response: NewsPostResponse): NewsPost {
  return {
    id: response.id,
    title: response.title,
    body: response.body,
    createdAt: response.dateCreated,
    updatedAt: response.dateModified ?? null,
    isPinned: response.pinned,
    attachments: (response.attachments ?? []).map(toNewsAttachment),
  }
}
